import { StorageService } from '../../shared/logic/storage-service';

export interface GammaFactor {
    gammaFactor: number;
    calibrationColor: string;
}

export class GammaCorrectionLogic {
    private static _instance: GammaCorrectionLogic | null = null;
    private static _storageKey = 'videbisGammaCorrection';
    private readonly _gammaFactors: GammaFactor[];
    private _currentIndex: number;
    private _storageService: StorageService;

    static getInstance(): GammaCorrectionLogic {
        if (!GammaCorrectionLogic._instance) {
            GammaCorrectionLogic._instance = new GammaCorrectionLogic();
        }
        return GammaCorrectionLogic._instance;
    }

    changeColor(darker: boolean = true) {
        if (darker && this._currentIndex > 0) {
            --this._currentIndex;
        }
        if (!darker && this._currentIndex < this._gammaFactors.length - 1) {
            ++this._currentIndex;
        }

        this._storageService.set(
            GammaCorrectionLogic._storageKey, JSON.stringify(this._gammaFactors[this._currentIndex])
        );
    }

    getCorrectedColor(percentage: number): string {
        const pc = (percentage / 100);
        const gammaFactor = this._gammaFactors[this._currentIndex].gammaFactor;

        const newValue = (+(Math.pow((1 - pc) / (1 + pc), 1 / gammaFactor) * 0xff).toFixed());
        const newColor = newValue.toString(16);

        // console.log(percentage,pc, newValue, newColor);

        // Old: const newColor = (+(Math.pow(1 - pc, 1 / gammaFactor) * 0xff).toFixed()).toString(16);

        return `#${newColor}${newColor}${newColor}`;
    }

    getCurrentColor(): string {
        return this._gammaFactors[this._currentIndex].calibrationColor;
    }

    getGammaCorrection(): number {
        return this._gammaFactors[this._currentIndex].gammaFactor;
    }

    private constructor() {
        this._storageService = StorageService.getInstance();
        this._gammaFactors = [];
        this._gammaFactors.push({ gammaFactor: 0.8, calibrationColor: '#6B6B6B' });
        this._gammaFactors.push({ gammaFactor: 1.0, calibrationColor: '#7F7F7F' });
        this._gammaFactors.push({ gammaFactor: 1.2, calibrationColor: '#8E8E8E' });
        this._gammaFactors.push({ gammaFactor: 1.3, calibrationColor: '#949494' });
        this._gammaFactors.push({ gammaFactor: 1.4, calibrationColor: '#9A9A9A' });
        this._gammaFactors.push({ gammaFactor: 1.5, calibrationColor: '#A0A0A0' });
        this._gammaFactors.push({ gammaFactor: 1.6, calibrationColor: '#A5A5A5' });
        this._gammaFactors.push({ gammaFactor: 1.7, calibrationColor: '#A8A8A8' });
        this._gammaFactors.push({ gammaFactor: 1.8, calibrationColor: '#ADADAD' });
        this._gammaFactors.push({ gammaFactor: 2.0, calibrationColor: '#B3B3B3' });
        this._gammaFactors.push({ gammaFactor: 2.2, calibrationColor: '#B9B9B9' });
        this._gammaFactors.push({ gammaFactor: 2.4, calibrationColor: '#BEBEBE' });

        const buf: GammaFactor = JSON.parse(this._storageService.get(GammaCorrectionLogic._storageKey));

        if (!buf) {
            /* Set initial state to be: { gammaFactor: 1.5, color: '#A0A0A0' } */
            this._currentIndex = 5;
        } else {
            const i = this._gammaFactors.findIndex(el => el.calibrationColor === buf.calibrationColor);
            if (i === -1) {
                // Value not found bc session-storage is broken somehow. Delete the cached value and set initial state.
                this._storageService.del([GammaCorrectionLogic._storageKey]);
                this._currentIndex = 5;
            } else {
                this._currentIndex = i;
            }
        }
    }
}
